export default __webpack_public_path__ + "static/media/elevate-wht-banner-3.eede1176.jpg";